import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
  Email,
  Password
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [posting, setPosting] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = () => {
    if (email === "") {
      toast.warn("Failed. Fill in the family code", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (password === "") {
      toast.warn("Failed. Fill in your password", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPosting(true);
    const dataObj = {
      email,
      password,
    };

    const baseUrl = apilink.link;
    axios
      .post(`${baseUrl}/family/signin`, dataObj)
      .then((response) => {
        if (response.data.message === "Sign in successfull") {
          const user = response.data.account;
          console.log(user);
          localStorage.setItem("userSessionData", JSON.stringify(user));
          setPosting(false);
          setEmail("");
          setPassword("");
          navigate("/admin");
          return;
        } else {
          
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setPosting(false);
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating post");
      });

 
  };

  const handleMemberSignIn = () => {
    navigate("/");
  };
  const handleMemberSignUp = () => {
    navigate("/signup");
  };


  return (
    <>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "76px",
          paddingInline: 30,
        }}
      >
        <img
          alt="logo"
          style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
          src={require("./pic1.webp")}
        />
        <h1
          className="navbar-brand mb-0"
          style={{ fontFamily: "Caveat", fontSize: 20 }}
        >
          family<b>Tree</b>
        </h1>
        <p
          style={{
            color: "#779d38",
            fontFamily: "Open Sans",
            marginTop: "80px",
          }}
        >
          Family Admin Sign In
        </p>
        <div
          style={{
              width: "320px",
              borderWidth: 1,
              borderColor: "#779d38",
              backgroundColor: "#779d38",
              borderRadius: 5,
              height: 50,
              marginBottom: "10px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
        >
          <div style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}>
              <Email style={{ color: "#ffffff" }} />
          </div>
          <div style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <input
              style={{
                height: 48.2,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: 'none',

              }}
              value={email}
              placeholder="Family tree code"
              onChange={(e) => {setEmail(e.target.value)}}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
              width: "320px",
              borderWidth: 1,
              borderColor: "#779d38",
              backgroundColor: "#779d38",
              borderRadius: 5,
              height: 50,
              marginBottom: "10px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
        >
          <div style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}>
              <Password style={{ color: "#ffffff" }} />
          </div>
          <div style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <input
              style={{
                height: 48.8,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: 'none'
              }}
              value={password}
              type="password"
              placeholder="Password"
              onChange={(e) => {setPassword(e.target.value)}}
            />
          </div>
          <div></div>
        </div>
        <button
          onClick={() => handleSignIn()}
          style={{
            width: "320px",
            backgroundColor: "#779d38",
            borderRadius: 5,
            border: "none",
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            color: "white",
            marginTop: "10px",
          }}
        >
          {posting === false && <>Proceed</>}
          {posting && (
            <>
              <Squares />
            </>
          )}
        </button>
        <p
          onClick={() => handleMemberSignIn()}
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "30px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          Family member <span style={{ color: "#779d38" }}>Sign In</span>
        </p>
        <p
          onClick={() => handleMemberSignUp()}
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "20px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          Don't have account <span style={{ color: "#779d38" }}>Sign Up</span>
        </p>
        
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default SignIn;
